import { Driver } from '../localStorage';

export const driver:Driver = 'localStorage' in globalThis ? globalThis.localStorage : null;